module.exports = __webpack_public_path__ + "static/media/frames_Q6B.c5826fee.png";